import WalletTransactionsContainer from "../../container/admin/wallet-transactions";

const WalletTransactions = () => {
    return <WalletTransactionsContainer />;
};

export default WalletTransactions;